<template>

  <div>

    <div>
      <center>Input Code Referal:</center>
    </div>
    <div class="ma-auto position-relative" style="max-width: 300px">

      <v-otp-input ref="form" v-model="otp" :disabled="loading" @finish="onFinish"></v-otp-input>
      <v-overlay absolute :value="loading">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-overlay>
    </div>


    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="2000">
      {{ text }}
    </v-snackbar>

    <br>
    <br>

    <v-row align="center" justify="center">
      <v-overlay color="White" :absolute="absolute" :value="overlay">

        <div class="text-center">
          <v-progress-circular :size="70" :width="7" color="blue" indeterminate></v-progress-circular>
        </div>

      </v-overlay>
    </v-row>

    <div class="d-flex flex-column justify-space-between align-center">
      <v-img style="display:none;" :height="100" :width="100"
        src="https://cdn.vuetifyjs.com/images/parallax/material.jpg"></v-img>
    </div>




    <v-list-item v-for="(item, i) in items" :key="i">
      <v-list-item-icon>
        <v-icon v-text="item.icon"></v-icon>
      </v-list-item-icon>

      <v-list-item-content>
        <v-list-item-title v-text="item.text"></v-list-item-title>
      </v-list-item-content>

      <!-- <switch @change="onChange(item)" v-if="item.disabled==1" ref="form"
                
                  v-model="item.switch1"
                  inset
                ></switch> -->
      <RockerSwitch :size="0.9" :value="item.switch1" @change="isOn => (currentValue = isOn)(onChange(item))"
        v-if="item.disabled == 1" />

    </v-list-item>

    <br>

    <v-list-item v-for="(api, i) in apiKey" :key="i">

      <v-list-item-content>
        <span v-if="api.iot_token">Api key:</span>
        <v-list-item-title v-text="api.iot_token"></v-list-item-title>
      </v-list-item-content>


      <v-list-item-icon>
        <v-icon v-if="api.iot_token" v-text="api.icon" color="orange" x-large></v-icon>
      </v-list-item-icon>

    </v-list-item>

  </div>
</template>

<script>
// Import package
import RockerSwitch from "vue-rocker-switch";
// Import styles
import "vue-rocker-switch/dist/vue-rocker-switch.css";
import { mapGetters, mapActions } from 'vuex'
export default {
  props: {
    isOn: Boolean
  },
  data: () => ({
    items: [],
    apiKey: [],
    model: [0],
    dialogConfirm: false,
    absolute: true,
    overlay: false,

    loading: false,
    snackbar: false,
    snackbarColor: 'default',
    otp: '',
    text: '',
    currentValue: false,
  }),
  components: {
    RockerSwitch
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',

    })
  },
  mounted() {

    let config = {
      headers: {
        'Authorization': 'Bearer ' + this.user.api_token,
      },
    }
    let url = '/service_iot'
    // url = url + '?page='+this.page
    url = encodeURI(url)
    this.axios.get(url, config)
      .then((response) => {
        let { data } = response.data
        this.items = data
        this.clear()
        this.getApiKeyByUserId()

      })
      .catch((error) => {
        let { responses } = error
        console.log(responses)
      })

  },

  methods: {
    ...mapActions({
      setAlert: 'alert/set',
      setAuth: 'auth/set'
    }),
    onChange(event) {
      this.overlay = true
      var data = event;
      let formData = new FormData()
      formData.set('id', data.id)
      formData.set('switch1', this.currentValue)
      formData.set('icon', data.icon)
      formData.set('text', data.text)
      formData.set('iot_id', data.iot_id)
      let config = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }

      this.axios.post('/action_iot', formData, config)
        .then((response) => {
          let { data } = response
          this.setAuth(data.data)
          this.setAlert({
            status: true,
            text: data.message,
            color: 'success',
          })

          this.overlay = false


        })
        .catch((error) => {
          this.overlay = false
          let { data } = error
          this.setAlert({
            status: true,
            text: data.message,
            color: 'error',
          })
        })
    },

    onFinish(rsp) {
      this.loading = true
      setTimeout(() => {
        this.loading = false
        this.snackbarColor = (rsp === this.expectedOtp) ? 'success' : 'warning'
        this.text = `Processed OTP with "${rsp}" (${this.snackbarColor})`
        this.snackbar = true
        this.resetNow()

      }, 3500)
      let formData = new FormData()
      formData.set('referal_code', rsp)
      let config = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }

      this.axios.post('/referal_code', formData, config)
        .then((response) => {
          let { data } = response
          this.setAuth(data.data)
          this.setAlert({
            status: true,
            text: data.message,
            color: 'success',
          })

          this.overlay = false

          this.otp = ''
        })
        .catch((error) => {
          this.overlay = false
          let { data } = error
          this.setAlert({
            status: true,
            text: data.message,
            color: 'error',
          })
        })
    },
    resetNow() {
      location.reload();
      this.otp = ''

    },

    getApiKeyByUserId() {
      let config = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }

      let address = '/api_key_iot'
      //address = address + '?page='+this.page
      address = encodeURI(address)
      this.axios.get(address, config)
        .then((response) => {
          let { data } = response.data
          this.apiKey = data
          this.clear()
        })
        .catch((error) => {
          let { responses } = error
          console.log(responses)
        })
    },
    clear() {
      this.$refs.form.$forceUpdate()
    }
  }
}


</script>
<style scoped>
.v-progress-circular {
  margin: 1rem;
}

.position-relative {
  position: relative;
}
</style>